module.exports = __webpack_public_path__ + "img/demo-story.cd8ab3f6.png";